import { render } from "./ActivitiesFilter.vue?vue&type=template&id=9dfc71b2"
import script from "./ActivitiesFilter.vue?vue&type=script&lang=js"
export * from "./ActivitiesFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__